import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const headers: Record<string, EnhancedTableHeader> = {
  Production_Policy_PolicyNumber: {
    name: 'production_Policy_PolicyNumber',
    title: 'Policy Number',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/policies/{production_Policy_Id}',
    openUrlInNewTab: false,
  },
  Production_Policy_PolicyName: {
    name: 'production_Policy_PolicyName',
    title: 'Policy Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/policies/{production_Policy_Id}',
    openUrlInNewTab: false,
  },
  Line_Name: {
    name: 'line',
    title: 'Line',
    type: EnhancedTableHeaderType.Text,
  },
  subline_ExternalCode: {
    name: 'subline',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text,
  },
  plan_ExternalCode: {
    name: 'plan',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Policy_PolicyEffectiveDate: {
    name: 'effectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Policy_Status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Policy_StatusReason: {
    name: 'statusReason',
    title: 'Status Reason',
    type: EnhancedTableHeaderType.Text,
  },
};
